import React, { Component } from 'react'
import { connect } from 'react-redux'

// actions
import { setEmbeddedBookingContactInfo, saveEmbeddedBooking } from '../../../actions/embeddedbooking'

// Components
import Phone from '../../../shared/components/Phone'

// Elements
import Text from '../../../shared/elements/text'
import Button from '../../../shared/elements/button'

// utils
import { translation } from '../../../utils/helpers'

// Icons
import { EmbeddedBookingIcons } from '../../../shared/elements/icons'
import Icon from '../../../shared/elements/icon'

// Styles
import './contactinfoview.scss'

class ContactInfoView extends Component {
  constructor (props) {
    super(props)
    this.state = {
      ContactInfo: {
        ContactName: null,
        ContactLastName: null,
        ContactEmail: null,
        PhoneCode: this.props.phonecode,
        ContactPhone: null,
        Address: null,
        ZipCode: null,
        City: null
      },
      NameError: false,
      LastNameError: false,
      EmailError: false,
      PhoneError: false
    }
    this.onChange = this.onChange.bind(this)
    this.onPhoneChange = this.onPhoneChange.bind(this)
    this.onPhoneBlur = this.onPhoneBlur.bind(this)
    this.checkAndNav = this.checkAndNav.bind(this)
  }

  componentDidMount () {
    this.setState({
      CurrentStep: this.props.EmbeddedBooking.CurrentStep,
      ContactInfo: this.props.ContactInfo
    })
  }

  onPhoneChange (e) {
    let name = e.target.name
    let value = e.target.value
    if (name === 'PhoneCode') {
      this.setState({
        ContactInfo: {
          ...this.state.ContactInfo,
          IsDirty: true,
          PhoneCode: {
            Id: Number(value.Id)
          }
        }
      }, () => {
        this.props.saveEmbeddedBooking(this.state)
      })
    } else if (name === 'PhoneNumber') {
      this.setState({
        ContactInfo: {
          ...this.state.ContactInfo,
          IsDirty: true,
          ContactPhone: value
        },
        NameError: false,
        LastNameError: false,
        EmailError: false,
        PhoneError: false
      })
    }
  }

  onPhoneBlur () {
    this.props.saveEmbeddedBooking(this.state)
  }

  onChange (e) {
    let name = e.target.name
    switch (name) {   // In order to get correct autofill data for chrome
      case 'fname':
        name = 'ContactInfo.ContactName'
        break
      case 'lname':
        name = 'ContactInfo.ContactLastName'
        break
      case 'email':
        name = 'ContactInfo.ContactEmail'
        break
      case 'address':
        name = 'ContactInfo.Address'
        break
      case 'zipcode':
        name = 'ContactInfo.ZipCode'
        break
      case 'city':
        name = 'ContactInfo.City'
        break
    }

    let value = e.target.value
    let names = name.split('.')
    this.setState({
      ContactInfo: {
        ...this.state.ContactInfo,
        [names[1]]: value
      },
      NameError: false,
      LastNameError: false,
      EmailError: false,
      PhoneError: false
    })
  }

  checkAndNav (e, opt) {
    e.persist()
    let { ContactInfo } = this.state

    // get the value of each input in case of autofill
    let contactName = document.getElementById('fname').value
    let contactLastName = document.getElementById('lname').value
    let contactEmail = document.getElementById('email').value
    let contactPhone = document.getElementById('ContactPhone').value
    let address = document.getElementById('address').value
    let zipCode = document.getElementById('zipcode').value
    let city = document.getElementById('city').value

    let nameError = !ContactInfo.ContactName || ContactInfo.ContactName.length === 0
    let lastNameError = !ContactInfo.ContactLastName || ContactInfo.ContactLastName.length === 0
    let emailError = !ContactInfo.ContactEmail || ContactInfo.ContactEmail.length === 0
    let phoneError = !ContactInfo.ContactPhone || ContactInfo.ContactPhone.length === 0

    if (contactName) nameError = false
    if (contactLastName) lastNameError = false
    if (contactEmail) emailError = false
    if (contactPhone) phoneError = false

    if (nameError || lastNameError || emailError || phoneError) {
      this.setState({
        NameError: nameError,
        LastNameError: lastNameError,
        EmailError: emailError,
        PhoneError: phoneError
      })
    } else {
      this.setState({
        ContactInfo: {
          ...this.state.ContactInfo,
          ContactName: contactName,
          ContactLastName: contactLastName,
          ContactPhone: contactPhone,
          ContactEmail: contactEmail,
          Address: address,
          ZipCode: zipCode,
          City: city,
          IsDirty: true
        }
      }, () => {
        this.props.saveEmbeddedBooking(this.state).then(() => {
          this.props.onNavClick(e, opt)
        })
      })
    }
  }

  render () {
    let { ContactInfo } = this.state
    let requiredNameClass = this.state.NameError ? 'required' : ''
    let requiredLastNameClass = this.state.LastNameError ? 'required' : ''
    let requiredPhoneClass = this.state.PhoneError ? 'required' : ''
    let requiredEmailClass = this.state.EmailError ? 'required' : ''
    let leftChildren = true

    return (
      <div className='contact-info__view'>
        <article className='main'>
          {this.props.children}
          <h1>{translation(16691)}</h1>
          <Text id='fname' className={requiredNameClass} name='fname' placeholder={translation(18336) + ' *'} value={ContactInfo.ContactName || ''} onChange={this.onChange} onBlur={this.props.onBlur} autoComplete='given-name' />
          <Text id='lname' className={requiredLastNameClass} name='lname' placeholder={translation(18337) + ' *'} value={ContactInfo.ContactLastName || ''} onChange={this.onChange} onBlur={this.props.onBlur} autoComplete='family-name' />
          <Text id='address' name='address' placeholder={translation(19009)} value={ContactInfo.Address || ''} onChange={this.onChange} onBlur={this.props.onBlur} autoComplete='street-address' />
          <div className='zipCityWrapper'>
            <Text id='zipcode' name='zipcode' placeholder={translation(19010)} value={ContactInfo.ZipCode || ''} onChange={this.onChange} onBlur={this.props.onBlur} autoComplete='postal-code' />
            <Text id='city' name='city' placeholder={translation(19011)} value={ContactInfo.City || ''} onChange={this.onChange} onBlur={this.props.onBlur} autoComplete='address-level2' />
          </div>
          <Phone
            PhoneNumberClassName={requiredPhoneClass}
            onChange={this.onPhoneChange}
            onBlur={this.onPhoneBlur}
            code={ContactInfo.PhoneCode || { Id: 0 }}
            number={ContactInfo.ContactPhone || ''}
            placeholder={translation('38') + ' *'}
            Id={'ContactPhone'} />
          <Text id={'email'} className={requiredEmailClass} name='email' placeholder={translation(1052) + ' *'} value={ContactInfo.ContactEmail || ''} onChange={this.onChange} onBlur={this.props.onBlur} autoComplete='email' />
          <div className='ctaWrapper'>
            <Button style='secondary' labelText={translation('394')} onClick={(e) => this.props.onNavClick(e, 'previous')} leftChildren={leftChildren}>
              <Icon
                size='s'
                icon={EmbeddedBookingIcons.Left_Arrow}
                injectSvg
              />
            </Button>
            <Button labelText={translation(237)} onClick={(e) => this.checkAndNav(e, 'next')}>
              <Icon
                size='s'
                icon={EmbeddedBookingIcons.Right_Arrow}
                injectSvg
              />
            </Button>
          </div>
        </article>
        <aside className='side'>
          <section>
            <h1>{translation(18432)}</h1>
            <p>{translation(16746)}</p>
          </section>
        </aside>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    phonecode: state.common.phonecode,
    ContactInfo: state.embeddedbooking.ContactInfo,
    EmbeddedBooking: state.embeddedbooking
  }
}

export default connect(mapStateToProps, { setEmbeddedBookingContactInfo, saveEmbeddedBooking })(ContactInfoView)



// WEBPACK FOOTER //
// ./src/app/pages/EmbeddedBooking/ContactInfoView/index.js